export default "/images/vendor/flag-icons/flags/1x1/se.svg?1124c09af582f9d044369097d2bd4c48";